import { Injectable } from '@angular/core';
import { AppLocalization } from '../models/app-localization.model';
import { locale, loadMessages, formatMessage } from "devextreme/localization";
import { TypeHelper } from '../utils/type-helper.util';
import devExtremeEn from "../../../assets/localization/en.json";
import devExtremePl from "../../../assets/localization/pl.json";
import globalEn from "../../../assets/localization/global-en.json";
import globalPl from "../../../assets/localization/global-pl.json";
import enumsEn from "../../core/enums-en.json";
import enumsPl from "../../core/enums-pl.json";
import authEn from "../../modules/core/auth/auth-en.json"
import authPl from "../../modules/core/auth/auth-pl.json"
import accountEn from "../../modules/core/account/account-en.json"
import accountPl from "../../modules/core/account/account-pl.json"
import usersEn from "../../modules/core/users/users-en.json"
import usersPl from "../../modules/core/users/users-pl.json"
import rolesEn from "../../modules/core/roles/roles-en.json"
import rolesPl from "../../modules/core/roles/roles-pl.json"
import contractorsEn from "../../modules/system/contractors/contractors-en.json"
import contractorsPl from "../../modules/system/contractors/contractors-pl.json"
import ordersEn from "../../modules/system/orders/orders-en.json"
import ordersPl from "../../modules/system/orders/orders-pl.json"
import transportOrdersEn from "../../modules/system/transport-orders/transport-orders-en.json"
import transportOrdersPl from "../../modules/system/transport-orders/transport-orders-pl.json"
import squareVehiclePickupsEn from "../../modules/system/square-vehicle-pickups/square-vehicle-pickups-en.json"
import squareVehiclePickupsPl from "../../modules/system/square-vehicle-pickups/square-vehicle-pickups-pl.json"
import transportOrderOffersEn from "../../modules/system/transport-order-offers/transport-order-offers-en.json"
import transportOrderOffersPl from "../../modules/system/transport-order-offers/transport-order-offers-pl.json"

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  private locales: Record<string, string> = {
    'en-US': 'English',
    'pl-PL': 'Polish'
  }

  public defaultLocale: string = 'pl-PL';

  private notificationsLanguages: Record<string, string> = {
    'en-US': 'English',
    'fr-FR': 'French',
    'pl-PL': 'Polish'
  }

  public defaultNotificationsLanguages: string = 'pl-PL';

  constructor() {
    console.log('LocalizationService');
  }

  public setUserLocale(userPreferredLanguage: string) {

    const localeStorageKey = 'locale';
    let userLocale = this.defaultLocale;

    if (!TypeHelper.isNullOrEmpty(userPreferredLanguage) && this.localeExists(userPreferredLanguage)) {

      userLocale = userPreferredLanguage;
      localStorage.setItem(localeStorageKey, userLocale);

    } else {
      const storageLocale = localStorage.getItem(localeStorageKey) ?? '';

      if (!TypeHelper.isNullOrEmpty(storageLocale) && this.localeExists(storageLocale)) {
        userLocale = storageLocale as string;
      } else if (!TypeHelper.isNullOrEmpty(navigator.language) && this.localeExists(navigator.language)) {
        userLocale = navigator.language;
      }
    }

    switch(userLocale) {
      case 'en-US':
        loadMessages(devExtremeEn);
        loadMessages(globalEn);
        loadMessages(enumsEn);
        loadMessages(authEn);
        loadMessages(accountEn);
        loadMessages(usersEn);
        loadMessages(rolesEn);
        loadMessages(contractorsEn);
        loadMessages(ordersEn);
        loadMessages(transportOrdersEn);
        loadMessages(squareVehiclePickupsEn);
        loadMessages(transportOrderOffersEn);
      break;
      case 'pl-PL':
        loadMessages(devExtremePl);
        loadMessages(globalPl);
        loadMessages(enumsPl);
        loadMessages(authPl);
        loadMessages(accountPl);
        loadMessages(usersPl);
        loadMessages(rolesPl);
        loadMessages(contractorsPl);
        loadMessages(ordersPl);
        loadMessages(transportOrdersPl);
        loadMessages(squareVehiclePickupsPl);
        loadMessages(transportOrderOffersPl);
      break;
    }

    locale(userLocale);
  }

  public localeExists(code: string): boolean {
    return this.locales.hasOwnProperty(code);
  }

  public getLocalizations(): AppLocalization[] {

    let result: AppLocalization[] = [];

    Object.entries(this.locales).forEach(([k, v]) => {
      result.push({
        code: k,
        name: formatMessage(v)
      });
    });

    return result;
  }

  public getNotificationsLanguages(): AppLocalization[] {

    let result: AppLocalization[] = [];

    Object.entries(this.notificationsLanguages).forEach(([k, v]) => {
      result.push({
        code: k,
        name: formatMessage(v)
      });
    });

    return result;
  }
}
